package kz.dentalcrm.app.data.network.request_model

import kotlinx.serialization.Serializable

@Serializable
data class AddEmployeeBody(
    val name: String,
    val surname: String,
    val patronymic: String? = null,
    val phone: String,
    val gender: String,
    val birth_date: String,
    val color: String,
    val positions: List<kz.dentalcrm.app.data.network.response_model.employees.Position>? = null,
    val services: List<kz.dentalcrm.app.data.network.response_model.services.Service>? = null,
    val email: String? = null,
    val password: String? = null,
    val permissions: List<kz.dentalcrm.app.data.network.response_model.permissions.Permission>? = null,
    val create_account: Boolean,
    val role_id: Int
)